import { mediaQuery } from '../../scripts/lib/mediaQuery';

export default {
  template: '#stoerer-template',

  props: {
    siegel: {
      type: Array,
      required: false,
    },
    previewColor: {
      type: Object,
      required: false,
    },
    priceReduction: {
      type: String,
      required: false,
    },
    active: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    isMobileViewport: mediaQuery.up_to_L,
  }),

  beforeMount() {
    const entsDataElement = document.querySelector('#stoerer-data');
    this.neuFlagData = JSON.parse(entsDataElement.dataset.bewertenJsonNeuflag);

    mediaQuery.on('change:width', () => {
      this.isMobileViewport = mediaQuery.up_to_L;
    });
  },

  computed: {
    isNew() {
      if (this.active.farben) {
        return this.neuFlagData.newItems.includes(this.previewColor ? this.previewColor.farbId : this.active.farben.aktiv.farbId);
      }
      return this.neuFlagData.newItems.includes(this.active.verkaufId);
    },
  },
};
